import React, {Component} from 'react'
import MonthlyBonus from './monthlyBonus.jsx'
import TotalBonus from './totalBonus.jsx'
import HelpYourReferrals from './helpYourReferrals.jsx'

export default class Bonus extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="bonus">
                <div className="bonus_header_block">
                    <div>
                        <h2><a href="/">Bonus</a></h2>
                        <hr/>
                    </div>
                </div>
                <div className="bonus_left-side">
                    <p><span>Bonus is</span> a CashBack service that returns 2% of all your costs. So same 2% from spending all your referrals and 0.5% from all spending referrals your referrals.</p>
                    <p>If you do not spend 2000 CPT in the bonus, the monthly bonus is lost.</p>
                    <p>If your referral does not spend more than 4 months, it ceases to be your referral.</p>
                    <p><span>Want more bonus?</span></p>
                    <p className="answer">Invite more friends</p>
                    <p className="answer">help them use apps more actively</p>
                </div>
                <div className="bonus_right-side">
                    <div className="bonus_right-side_left">
                        <MonthlyBonus/>
                        <TotalBonus/>
                    </div>
                    <div className="bonus_right-side_right">
                        <HelpYourReferrals/>
                    </div>
                </div>
            </div>
        )
    }
}
